import React from 'react'
import RetourCourt from '../components/RetourCourt'

function Racines() {
  return (
    <div>
         <div>
        <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Adam, un jeune chasseur, est persuadé qu’un danger rôde dans une forêt en proie à d’étranges phénomènes. Mais lorsqu’un de ses amis y est retrouvé mort, cette crainte devient une certitude. Adam décide alors de retourner dans les bois, déterminé à trouver la source de cette menace.</p>
    </div>
    <div style={{textAlign:"center"}}> <RetourCourt /></div>
    </div>
    </div>
    </div>
  )
}

export default Racines